import { useMutation } from "@apollo/client";

import { GqlSettingsResearchTypeSpeciesCreateInput } from "~/__generated__";

import { SettingsResearchTypeEditRoute_AddSpeciesDocument } from "../mutations.generated";
import {
    SettingsResearchTypeEditRoute_GetByIdDocument,
    SettingsResearchTypeEditRoute_SpeciesGetAllAssignableDocument,
} from "../queries.generated";

export default function useSettingsResearchTypeEditRoute_AddSpecies() {
    const [mutate, { loading, error }] = useMutation(SettingsResearchTypeEditRoute_AddSpeciesDocument, {
        refetchQueries: [
            SettingsResearchTypeEditRoute_GetByIdDocument,
            SettingsResearchTypeEditRoute_SpeciesGetAllAssignableDocument,
        ],
    });

    const addResearchTypeSpecies = async (input: GqlSettingsResearchTypeSpeciesCreateInput): Promise<void> => {
        await mutate({ variables: { input } });
    };

    return {
        loading,
        error,
        addResearchTypeSpecies,
    };
}
